import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import { Grid } from '@material-ui/core';

import BookingCard from './BookingCard';

function Bookings({
	bookingId,
	bookings = [],
	details,
	removeProduct,
	removeBooking,
	proceedToCheckout,
}) {
	const classes = useStyles();

	const rooms = bookings.filter(b => b.productAssetType === 'room');
	const upgrades = bookings.filter(b => b.upgrade);

	return (
		<div className={classes.bookings}>
			<Grid container spacing={3}>
				{rooms.map((booking, i) => {
					return (
						<Grid key={`booking-${i}`} item xs={12}>
							<BookingCard
								bookingId={bookingId}
								booking={booking}
								details={details}
								upgrades={upgrades}
								removeProduct={removeProduct}
								removeBooking={removeBooking}
								proceedToCheckout={proceedToCheckout}
							/>
						</Grid>
					);
				})}
			</Grid>
		</div>
	);
}

Bookings.propTypes = {
	bookingId: PropTypes.string.isRequired,
	bookings: PropTypes.array,
	details: PropTypes.object,
	removeProduct: PropTypes.func,
	removeBooking: PropTypes.func,
	proceedToCheckout: PropTypes.bool,
};

export default Bookings;

const useStyles = makeStyles(theme => ({
	bookings: {
		paddingBottom: theme.spacing(5),
	},
}));
